module.exports = __webpack_public_path__ + "static/media/villagewood-place.8475769c.pdf";